(() => {
  const anchor = document.getElementById('icon-fonts-subsets');
  if (!anchor) return;

  const families = new Map([
    ['fi-tr-', { name: 'thin-rounded', known: new Set(['fi-tr-plus-small']) }],
    ['fi-ss-', { name: 'solid-straight', known: new Set(['fi-ss-call-history', 'fi-ss-marker']) }],
    ['fi-sr-', { name: 'solid-rounded', known: new Set(['fi-sr-envelope']) }],
  ]);
  const requested = new Map();
  const inspected = new WeakMap();
  const selector = '[class*="fi-tr-"],[class*="fi-ss-"],[class*="fi-sr-"]';

  function requestFamily(prefix, family) {
    if (requested.has(prefix)) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn-uicons.flaticon.com/4.0.0/uicons-' + family.name + '/css/uicons-' + family.name + '.css';
    // Preserve the original tr -> ss -> sr cascade regardless of discovery order.
    const order = [...families.keys()];
    const next = order.slice(order.indexOf(prefix) + 1).map(key => requested.get(key)).find(Boolean);
    (next || anchor).before(link);
    requested.set(prefix, link);
  }

  function inspect(element) {
    const tokens = [...element.classList].filter(token =>
      token.startsWith('fi-tr-') || token.startsWith('fi-ss-') || token.startsWith('fi-sr-')
    );
    const signature = tokens.slice().sort().join(' ');
    if (inspected.get(element) === signature) return;
    if (tokens.length) inspected.set(element, signature);
    else inspected.delete(element);

    const glyphs = [];
    for (const token of tokens) {
      for (const [prefix, family] of families) {
        if (token.startsWith(prefix)) glyphs.push({ token, prefix, family });
      }
    }
    const ambiguous = glyphs.length > 1;
    // Disable both local content and local font-family for mixed glyph classes.
    element.toggleAttribute('data-icon-fonts-full', ambiguous);
    for (const { token, prefix, family } of glyphs) {
      if (ambiguous || !family.known.has(token)) requestFamily(prefix, family);
    }
  }

  const pendingTrees = new Set();
  const pendingElements = new Set();
  let flushScheduled = false;

  function flushMutations() {
    flushScheduled = false;
    const trees = new Set(pendingTrees);
    const elements = new Set(pendingElements);
    pendingTrees.clear();
    pendingElements.clear();

    for (const tree of trees) {
      if (!tree.isConnected) continue;
      let ancestor = tree.parentElement;
      while (ancestor && !trees.has(ancestor)) ancestor = ancestor.parentElement;
      if (ancestor) continue;
      if (tree.matches(selector)) elements.add(tree);
      for (const element of tree.querySelectorAll(selector)) elements.add(element);
    }
    for (const element of elements) {
      if (element.isConnected) inspect(element);
    }
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes' && mutation.target instanceof Element) {
        if (inspected.has(mutation.target) || mutation.target.matches(selector)) {
          pendingElements.add(mutation.target);
        }
      } else {
        for (const node of mutation.addedNodes) {
          if (node instanceof Element && node.isConnected) pendingTrees.add(node);
        }
      }
    }
    if (!flushScheduled && (pendingTrees.size || pendingElements.size)) {
      flushScheduled = true;
      queueMicrotask(flushMutations);
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class'],
  });
  // Deferred scripts start after parsing; existing icons produce no added-node record.
  pendingTrees.add(document.documentElement);
  flushMutations();
})();
